import { render, staticRenderFns } from "./WashProductBrand.vue?vue&type=template&id=476b48ed&scoped=true&"
import script from "./WashProductBrand.vue?vue&type=script&lang=js&"
export * from "./WashProductBrand.vue?vue&type=script&lang=js&"
import style0 from "./WashProductBrand.vue?vue&type=style&index=0&id=476b48ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476b48ed",
  null
  
)

export default component.exports